// Vendor
import * as React from 'react';

// Vendor Components
import Button from 'material-ui/Button';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import {translate, TranslationFunction} from 'react-i18next';
import {compose} from 'recompose';

// Types
interface Props {}

interface State {
  reloadIn: number;
}

interface TranslatedProps {
  t: TranslationFunction;
}

type EnhancedProps = TranslatedProps;

const enhance = compose<EnhancedProps, Props>(translate());

class ErrorDialog extends React.Component<EnhancedProps, State> {
  public readonly state: Readonly<State> = {
    reloadIn: 5
  };

  public componentDidMount() {
    setTimeout(this.tick, 1000);
  }

  public componentDidUpdate() {
    if (this.state.reloadIn === 0) this.reload();
  }

  public render() {
    const {t} = this.props;
    const {reloadIn} = this.state;

    return (
      <Dialog open={true}>
        <DialogTitle>{t('async_component.error_dialog.title')}</DialogTitle>

        <DialogContent>
          <DialogContentText>
            {t('async_component.error_dialog.content', {reloadIn})}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.reload} color="primary" autoFocus>
            {t('async_component.error_dialog.actions.reload')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  private tick = () => {
    if (this.state.reloadIn > 1) setTimeout(this.tick, 1000);
    this.setState(({reloadIn}) => ({reloadIn: reloadIn - 1}));
  };

  private reload() {
    window.location.reload();
  }
}

export default enhance(ErrorDialog);



// WEBPACK FOOTER //
// ./src/ui/components/async-component/components/error-dialog/error-dialog.tsx